import React from "react";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import Checkbox from "@material-ui/core/Checkbox";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import { FastField, Field } from "formik";
import { getFieldStatus } from "./common";

const checkedIcon = <CheckBoxIcon fontSize="small" />;
const uncheckedIcon = <CheckBoxOutlineBlankIcon fontSize="small" />;

export default ({
  name,
  label: labelProp = name,
  required,
  disabled: disabledProp,
  value: valueProp,
  labelPlacement,
  fast = true,
  FieldComponent = fast ? FastField : Field,
  ...props
}) => (
  <FieldComponent name={name}>
    {({ field, form }) => {
      const { error, hasError, disabled, label, value } = getFieldStatus(
        form,
        field,
        valueProp,
        labelProp,
        disabledProp
      );

      const inputProps = {
        ...field,
        value: field.value === null ? "" : field.value
      };

      return (
        <FormControl error={hasError} required={required}>
          <FormControlLabel
            control={
              <Checkbox
                aria-label={label}
                checkedIcon={checkedIcon}
                icon={uncheckedIcon}
                color="primary"
                inputProps={inputProps}
                checked={Boolean(value)}
                {...props}
              />
            }
            label={label}
            disabled={disabled}
            labelPlacement={labelPlacement}
          />
          {hasError && <FormHelperText>{error}</FormHelperText>}
        </FormControl>
      );
    }}
  </FieldComponent>
);
